export default __webpack_public_path__ + "static/media/grape_logo_main.5016f55b.svg";